// Accounting Cashiers Vuex

import state from './receiveStates.js'
import * as getters from './receiveGetters.js'
import * as mutations from './receiveMutations.js'
import * as actions from './receiveActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
